export default __webpack_public_path__ + "static/media/family_avatar_2.412cd1e7.svg";